import skuIsOverQuantityLimit from './skuIsOverQuantityLimit';
import {CartSkuOption} from '../types';

/**
 * Returns whether or not a quantity of the given sku may be added to the cart.
 */
export default function calcCanAddSkuToCart(sku: CartSkuOption, quantity: number, amountIsValid?: boolean): boolean {
  return (
    !skuIsOverQuantityLimit(sku, quantity) &&
    sku.isAvailableForPurchase &&
    (amountIsValid || amountIsValid === undefined)
  );
}
